export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-12.e91921ac.jpg";